import { parseHtml } from '@fmpedia/html-tools'

export { parseHtml }
